import gsap from "gsap";

export function render() {
  const borders = document.querySelectorAll(".c-border");
  const event = new CustomEvent("enter");
  const header = document.querySelector(".c-header");
  const title = document.querySelector(".l-hero__title");

  const menu = document.querySelector(".c-menu");
  const border = menu.querySelector(".c-border");
  const icons = menu.querySelectorAll(".c-menu__icon");
  const subtitle = menu.querySelector(".c-menu__domain");

  let heroEnter = gsap.timeline();

  document.addEventListener("loader", () => {
    if (window.innerWidth > 1024) {
      heroEnter
        .to(title, {
          autoAlpha: 1,
          duration: 0.5,
        })
        .to(
          border,
          {
            duration: 0.1,
            ease: "linear",
            height: "100%",
          },
          0.25
        )
        .to(
          header,
          {
            duration: 0.5,
            ease: "Power1.easeOut",
            translateY: 0,
          },
          0.5
        )
        .to(
          subtitle,
          {
            autoAlpha: 1,
            duration: 0.5,
            ease: "Power1.easeOut",
            translateY: 0,
          },
          0.5
        )
        .to(
          icons,
          {
            ease: "Circ.easeOut",
            stagger: {
              each: 0.15,
            },
            translateX: 0,
          },
          1
        );
    } else {
      heroEnter
        .to(title, {
          autoAlpha: 1,
          duration: 0.5,
        })
        .to(
          header,
          {
            duration: 0.5,
            ease: "Power1.easeOut",
            translateY: 0,
          },
          0.5
        )
        .to(
          subtitle,
          {
            autoAlpha: 1,
            duration: 0.5,
            ease: "Power1.easeOut",
            translateY: 0,
          },
          0.75
        )
        .to(
          icons,
          {
            ease: "Circ.easeOut",
            stagger: {
              each: 0.15,
            },
            translateX: 0,
          },
          1
        )
        .to(borders, {
          duration: 0.4,
          ease: "easeOut",
          stagger: {
            each: 0.15,
          },
          width: "100%",
        })
        .add(() => {
          document.dispatchEvent(event);
        });
    }
  });
}
